import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import ProtectedRoute from '../components/feature/ProtectedRoute';

const HomePage = lazy(() => import('../pages/home/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const SignupPage = lazy(() => import('../pages/signup/page'));
const ResetPasswordPage = lazy(() => import('../pages/reset-password/page'));
const DashboardPage = lazy(() => import('../pages/dashboard/page'));
const ProjectsPage = lazy(() => import('../pages/projects/page'));
const NewProjectPage = lazy(() => import('../pages/new-project/page'));
const ProjectDetailPage = lazy(() => import('../pages/project-detail/page'));
const IntegrationsPage = lazy(() => import('../pages/integrations/page'));
const SettingsPage = lazy(() => import('../pages/settings/page'));
const HelpPage = lazy(() => import('../pages/help/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/signup',
    element: <SignupPage />,
  },
  {
    path: '/reset-password',
    element: <ResetPasswordPage />,
  },
  {
    path: '/dashboard',
    element: (
      <ProtectedRoute>
        <DashboardPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/projects',
    element: (
      <ProtectedRoute>
        <ProjectsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/new-project',
    element: (
      <ProtectedRoute>
        <NewProjectPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/project/:id',
    element: (
      <ProtectedRoute>
        <ProjectDetailPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/integrations',
    element: (
      <ProtectedRoute>
        <IntegrationsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/settings',
    element: (
      <ProtectedRoute>
        <SettingsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/help',
    element: (
      <ProtectedRoute>
        <HelpPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
